/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import EditableText from 'material/embeds/editabletext/editabletext_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/shared/question/question_styles';
import {pxToEm, getElementCSSProperty} from 'utils/embeds/styles';



/* ========== ~~~~~~~~~~ EMBED : QUESTION : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Question extends Component {
	constructor(props) {
		super(props);
		this.prevCharAmount = 0;
		this.characterLimit = 134; // 134 from UX (Will)
		this.state = { fontSize: 'standard' };
		this.availableQuesSizes = ['standard', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge']; // array of all available font sizes
	}
	componentDidMount() {
		// this.validateText(this.props.contentTitle, getElementCSSProperty(document.querySelector('.embededitor .question .text'), 'height'));
		this.validateText(this.props.contentTitle);
	}
	componentDidUpdate(prevProps, prevState, snapshot): void {
		if(prevProps.contentId !== this.props.contentId) this.setState({fontSize: 'standard'});
	}

	// adjustFontSize = (text, textHeightPX) => {
	// 	const charAmount = text === null ? 0 : text.length;
	// 	const staticDivHeight = parseInt(getElementCSSProperty(document.querySelector('.embededitor .question .text'), 'height'), 10);
	// 	let textHeight = parseInt(textHeightPX, 10);
	// 	// console.log('Chars:', 'prev:', this.prevCharAmount, 'new:', charAmount)
	// 	// console.log('----- static div height -----');
	// 	// console.log(staticDivHeight);
	// 	// console.log('----- text height -----')
	// 	// console.log(textHeight);
	// 	if(charAmount > this.prevCharAmount) {
	// 		if (textHeight > staticDivHeight) {
	// 			this.setState({ fontSize: this.state.fontSize - 2.1})
	// 		}
	// 	} else {
	// 		if (textHeight < staticDivHeight) {
	// 			this.setState({ fontSize: this.state.fontSize + 0.3 < 22 ? this.state.fontSize + 0.3 : 22 });
	// 		}
	// 	}
	// 	this.prevCharAmount = charAmount;
	// };
	adjustFontSize(text) {
		const charAmount = text !== null ? text.length: '';
		let quesSize = 'standard';
		// 24 chars per line at 22px fontsize
		// 58 is limit for 3 lines at 22px fontsize
		if ((charAmount >= 58) && (charAmount < 78)) { quesSize = 'medium'; }
		if ((charAmount >= 78) && (charAmount < 104)) { quesSize = 'large'; }
		if ((charAmount >= 104) && (charAmount < 128)) { quesSize = 'xlarge'; }
		if ((charAmount >= 128) && (charAmount < 152)) { quesSize = 'xxlarge'; }
		if (charAmount >= 152) { quesSize = 'xxxlarge'; }
		// troy - we should impose a limit from the embed workflow (dashboard) application
		// calling in the state update callback function to check if font size needs readjusting
		this.setState({
			fontSize: quesSize
		}, () => this.readjustFontSize())
	}

	// the current height and width of the question elements are grabbed and checked here and font size is adjusted accordingly.
	// Now we have the exact height of question element and so we can adjust the font size accordingly.
	// in very rare cases, this function will be called more than 2 times. So no loop here.
	readjustFontSize() {
		let currQuesSize = this.state.fontSize;
		const currQuesSizeIndex = this.availableQuesSizes.indexOf(currQuesSize);
		if (this.questionEl && (this.getQuestionContainerDimensions().height - this.getQuestionElementDimensions().height) < 10 && currQuesSize !== 'xxxlarge' ) {
			currQuesSize = this.availableQuesSizes[currQuesSizeIndex + 1] ? this.availableQuesSizes[currQuesSizeIndex + 1] : currQuesSize;
			this.setState({
				fontSize: currQuesSize
			}, () => this.readjustFontSize()); // again calling it just in case to see if fonts need more readjustment. Wont be called unless font needs resizing.
		}
	}
	getQuestionContainerDimensions() {
		const el = this.questionEl;
		let height = el.clientHeight;
		return { width: el.clientWidth, height: height };
	}

	getQuestionElementDimensions() {
		const el = this.questionEl.firstChild;
		return { width: el.clientWidth, height: el.clientHeight };
	}
    validateText = (text) => {
    	this.adjustFontSize(text);
        if(text === null || text.length > this.characterLimit) { return null; }
        const isValid = this.props.isValid;
        if (text.length > 0 && !isValid) {
            this.props.setQBProperty(this.props.contentId, 'isTitleValid', true)
        } else if (text.length === 0 && (isValid || isValid === null)) {
            this.props.setQBProperty(this.props.contentId, 'isTitleValid', false)
        }
    }
    handleSelect = () => {
    	if(!this.props.isValid) { this.props.setQBProperty(this.props.contentId, 'isTitleValid', null) }
	}
    render() {
		const placeholderText = 'Type your question here';
		// style={{fontSize: `${pxToEm(this.state.fontSize)}`}}
        return(
            <div  className={`question ${this.props.classes.question} valid-${this.props.isValid}`}>
				<h3 ref={(input) => this.questionEl = input} className={`text ${this.state.fontSize}`} >
					<EditableText contentId={this.props.contentId}
                                  contentTitle={this.props.contentTitle}
                                  isEditable={this.props.isEditable}
								  isOption={false}
								  optionId={null}
								  placeholderText={placeholderText}
						          onKeyUp={this.validateText}
								  onBlur={this.validateText}
								  onFocus={this.handleSelect}
								  isSelected={true}
								  preventEnter={true}
								  characterLimit={this.characterLimit}
								  validateText={this.validateText}
					/>
				</h3>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(Question);
